import { useMemo } from 'react';

import { useAppContext } from '../../common/ui/app-context';
import {
	useApplicationMode,
	useAvailableProducts,
	useExperimentConfig,
	useFeatures,
	usePrimaryProduct,
	useProductEdition,
	useSearchSessionId,
} from '../store/bootstrap';
import {
	useCQL,
	useFilterAttributesForTracking,
	useInputQuery,
	useQueryUpdatedTime,
	useResultsRequestId,
	useResultsSort,
	useSearchQuery,
	useSelectedProduct,
} from '../store/search';
import type { GetAttributesType } from './utils';

export const useCommonAttributeInputs = (): GetAttributesType => {
	const [searchSessionId] = useSearchSessionId();
	// eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
	const [requestId] = useResultsRequestId();
	const [searchQuery] = useSearchQuery();
	const [inputQuery] = useInputQuery();
	// eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
	const [queryUpdatedTime] = useQueryUpdatedTime();
	const [productSelected] = useSelectedProduct();
	const availableProducts = useAvailableProducts();
	const [sort] = useResultsSort();
	const [experimentConfig] = useExperimentConfig();
	const filters = useFilterAttributesForTracking();
	const applicationMode = useApplicationMode();
	const [productEdition] = useProductEdition();
	const cqlState = useCQL();
	const [primaryProduct] = usePrimaryProduct();
	const { queryParams } = useAppContext();
	const [features] = useFeatures();
	const isLiteMode = features?.lite?.enabled ?? false;

	return useMemo(
		() => ({
			searchSessionId,
			requestId,
			searchQuery,
			inputQuery,
			filters,
			queryUpdatedTime,
			productSelected,
			availableProducts,
			sort,
			experimentConfig,
			applicationMode,
			productEdition,
			isCQL: !!cqlState,
			isLiteMode,
			primaryProduct,
			queryParams,
		}),
		[
			searchSessionId,
			requestId,
			searchQuery,
			inputQuery,
			filters,
			queryUpdatedTime,
			productSelected,
			availableProducts,
			sort,
			experimentConfig,
			applicationMode,
			productEdition,
			cqlState,
			isLiteMode,
			primaryProduct,
			queryParams,
		],
	);
};
